import htmlIcon from "./html-icon.svg";
import cssIcon from "./css-icon.svg";
import jsIcon from "./js-icon.svg";
import nodeIcon from "./node-icon.svg";
import reactIcon from "./react-icon.svg";
import typescriptIcon from "./typescript-icon.svg";
import bootstrapIcon from "./bootstrap-icon.svg";
import angular from "./angular.svg";
import express from "./express.svg";
import mongo from "./mongo.svg";
import sassIcon from "./sass-icon.svg";
import pwa from "./pwa-icon.svg";
import electron from "./electron.svg";

const icons = {
    htmlIcon,
    cssIcon,
    jsIcon,
    nodeIcon,
    reactIcon,
    typescriptIcon,
    bootstrapIcon,
    angular,
    express,
    mongo,
    sassIcon,
    pwa,
    electron
};

export default icons;
